import { DomainEvent } from '@frontend/sports/common/core/utils/dispatcher';

export interface SlideOutToBottomEventData {
    modalWindow?: HTMLElement | null;
    teardown?: () => void;
}

export class ModalGestureEvents {
    static readonly SlideOutToBottom = new DomainEvent<SlideOutToBottomEventData>('MODAL_GESTURE_SLIDE_OUT_TO_BOTTOM');
}
